import * as React from "react";
import { TableCell } from "@mui/material";
import { DataTable, type DataTableColumn } from "@/components/dashboard/DataTable";
import { QuantityCell } from "@/components/dashboard/QuantityCell";
import { PriceCell } from "@/components/dashboard/PriceCell";

export interface HoldingRow {
  instrument_token: string;
  exchange?: string | null;
  quantity: number;
  average_price: number;
  current_price?: number | null;
  market_value?: number | null;
}

interface HoldingTableProps {
  holdings: HoldingRow[];
}

export function HoldingTable({ holdings }: HoldingTableProps): React.JSX.Element {
  const columns: Array<DataTableColumn<HoldingRow>> = [
    {
      key: "instrument",
      label: "Instrument",
      sortable: true,
      sortValue: (row) => row.instrument_token,
      render: (row) => <TableCell key="instrument">{row.instrument_token}</TableCell>,
    },
    {
      key: "exchange",
      label: "Exchange",
      sortable: true,
      sortValue: (row) => row.exchange ?? "",
      render: (row) => (
        <TableCell key="exchange">
          {row.exchange ?? <span style={{ fontStyle: "italic", opacity: 0.6 }}>Not reported by backend</span>}
        </TableCell>
      ),
    },
    {
      key: "quantity",
      label: "Quantity",
      align: "right",
      sortable: true,
      sortValue: (row) => row.quantity,
      render: (row) => <QuantityCell key="quantity" value={row.quantity} />,
    },
    {
      key: "average_price",
      label: "Average Price",
      align: "right",
      sortable: true,
      sortValue: (row) => row.average_price,
      render: (row) => <PriceCell key="average_price" value={row.average_price} />,
    },
    {
      key: "current_price",
      label: "Current Price",
      align: "right",
      sortable: true,
      sortValue: (row) => row.current_price ?? 0,
      render: (row) => <PriceCell key="current_price" value={row.current_price} />,
    },
    {
      key: "market_value",
      label: "Market Value",
      align: "right",
      sortable: true,
      sortValue: (row) => row.market_value ?? 0,
      render: (row) => <PriceCell key="market_value" value={row.market_value} />,
    },
  ];

  return (
    <DataTable
      ariaLabel="Holdings"
      columns={columns}
      rows={holdings}
      getRowKey={(row) => row.instrument_token}
    />
  );
}
